// app/src/lib/scale/profile.js — user business profile (restaurant ZIP, tier).
//
// The ZIP is the restaurant's market area; the server tags anonymized pricing
// with it so prices can be benchmarked across restaurants in the same area.

import { getAccessToken } from '../auth/cognitoClient.js';
import { getConfig } from '../config.js';

export async function getProfile() {
  const at = await getAccessToken();
  if (!at) return null;
  const res = await fetch(`${getConfig().apiBaseUrl}/me/profile`, {
    headers: { authorization: `Bearer ${at}` },
  });
  if (!res.ok) throw new Error(`profile ${res.status}`);
  return res.json();
}

// Update any subset of the profile: { zip?, shareData? }. Returns the saved
// { zip, tier, shareData }.
export async function saveProfile(patch) {
  const at = await getAccessToken();
  if (!at) throw new Error('not signed in');
  const res = await fetch(`${getConfig().apiBaseUrl}/me/profile`, {
    method: 'PUT',
    headers: { authorization: `Bearer ${at}`, 'content-type': 'application/json' },
    body: JSON.stringify(patch || {}),
  });
  if (!res.ok) { const e = new Error(`profile ${res.status}`); e.status = res.status; throw e; }
  return res.json();
}

// Convenience wrapper retained for the ZIP field.
export function saveZip(zip) {
  return saveProfile({ zip });
}

// Select a plan. 'free' downgrades immediately; a paid tier records interest
// only (payments aren't wired yet) and is reflected as `requestedTier`.
export function selectPlan(tier) {
  return saveProfile({ tier });
}
